/**
 * MotoristaCancelamentoCarga
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Motorista} from '@/model/resource/Motorista'
import {MotoristaCancelamentoCargaCollection} from '@/model/collection/MotoristaCancelamentoCargaCollection'

/* TODO: review generated class */
export class MotoristaCancelamentoCarga extends Resource {
  idCancelamentoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  data: string | null = null

  get $id() {
    return this.idCancelamentoPk
  }
  set $id(val) {
    this.idCancelamentoPk = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of MotoristaCancelamentoCarga
   */
  async getMotoristaCancelamentoCarga(id: number) {
    return await Request.get(`/admin/motorista-cancelamento-carga/${id}`)
      .name('getMotoristaCancelamentoCarga')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of MotoristaCancelamentoCarga
   */
  static async listMotoristaCancelamentoCarga(params: any) {
    return await Request.get(`/admin/motorista-cancelamento-carga`, {params})
      .name('listMotoristaCancelamentoCarga')
      .as(MotoristaCancelamentoCargaCollection)
      .getData()
  }

  /**
   * Persists a new instance of MotoristaCancelamentoCarga. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistMotoristaCancelamentoCarga() {
    return await Request.post(`/admin/motorista-cancelamento-carga`, this)
      .name('persistMotoristaCancelamentoCarga')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of MotoristaCancelamentoCarga to use it in a CSV file
   */
  static async listCsvMotoristaCancelamentoCarga(params: any) {
    return await Request.get(`/admin/motorista-cancelamento-carga/csv`, {
      params,
    })
      .name('listCsvMotoristaCancelamentoCarga')
      .as(MotoristaCancelamentoCargaCollection)
      .getData()
  }
}
